<template>
  <div class="flex flex-wrap justify-center sm:justify-start">
    <div
      class="mb-2 mr-2 flex items-center px-4 py-2 text-[14px] font-medium leading-[17px]"
    >
      <SvgIcon
        name="eye-n"
        class="mr-2 size-4 text-new-card--title-black"
      ></SvgIcon>
      {{ views }}
    </div>

    <slot name="reactions" />

    <!-- ВРЕМЕННО СКРЫТО -->
    <div
      v-if="false"
      class="flex cursor-default select-none items-center px-4 py-2 text-[14px] font-medium leading-[17px]"
    >
      <SvgIcon
        name="like-n"
        class="mr-2 size-4 cursor-pointer"
        :class="[
          localIsLiked ? 'text-ruby-red-100' : 'text-new-card--title-black',
        ]"
        @click="handleLike"
      ></SvgIcon>
      Мне нравится
    </div>
    <CommonSocialsSocialSharingRedisign class="w-fit sm:ml-auto" />
  </div>
</template>

<script setup>
import api from '@/services/api/api';

const props = defineProps({
  id: { type: Number, required: true },
  modelType: { type: String, required: true },
  views: { type: Number, default: 0 },
});

const localIsLiked = ref(false);

const handleLike = async () => {
  const userLikesString = localStorage.getItem('likes');
  // в результате JSON.parse получаем массив id лайкнутых пользователем сущностей
  const userLikesParsed = JSON.parse(userLikesString) || [];
  const isLiked = userLikesParsed.indexOf(props.id) + 1;

  const like = async () => {
    try {
      await api.socials.handleLike({
        model_type: props.modelType,
        id: props.id,
      });

      if (!userLikesString) {
        localStorage.setItem('likes', JSON.stringify([props.id]));
      } else if (!isLiked) {
        userLikesParsed.push(props.id);
        localStorage.setItem('likes', JSON.stringify(userLikesParsed));
      }

      localIsLiked.value = true;
    } catch (e) {
      console.log(e);
    }
  };

  const dislike = async () => {
    try {
      await api.socials.handleDisLike({
        model_type: props.modelType,
        id: props.id,
      });
      if (userLikesString && isLiked) {
        userLikesParsed.splice(isLiked - 1, 1);
        localStorage.setItem('likes', JSON.stringify(userLikesParsed));
      }

      localIsLiked.value = false;
    } catch (e) {
      console.log(e);
    }
  };

  localIsLiked.value ? await dislike() : await like();
};
</script>

<style scoped lang="scss"></style>
